/**
 * Official UTMify UTM-tracking script.
 * Loaded once on app bootstrap from index.tsx via loadUtmify().
 * This file is additive and does not touch the Meta Pixel setup.
 */

const UTM_SCRIPT_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'

let loaded = false

export function loadUtmify(): void {
  if (loaded || typeof document === 'undefined') return
  loaded = true

  if (document.querySelector(`script[src="${UTM_SCRIPT_SRC}"]`)) return

  const script = document.createElement('script')
  script.src = UTM_SCRIPT_SRC
  script.async = true
  script.defer = true
  script.setAttribute('data-utmify-prevent-xcod-sck', '')
  script.setAttribute('data-utmify-prevent-subids', '')
  document.head.appendChild(script)
}
